import React from 'react';
import { HTTP_STATUS_MOVED_PERMANENTLY } from 'cityads-v3/utils/apiUtils';
import RedirectWithCode from './RedirectWithCode';

export default function PermanentRedirect(props) {
  return (
    <RedirectWithCode {...props} code={HTTP_STATUS_MOVED_PERMANENTLY} />
  );
}
